import packageJson from "../package.json";
const { version } = packageJson;

declare global {
  interface Window {
    REACT_APP_IHUB_PORTAL_VERSION: string;
  }
}

window.REACT_APP_IHUB_PORTAL_VERSION = version;

import("./bootstrap");

export {};
